import { axs } from './config/axiosConfig';
import { BASE_API_URL } from 'lib/setting';

const basePath = `${BASE_API_URL}/statistics`;

// "language":"EN"

export function fetchStatisticsList() {
  return axs({ url: `${basePath}`, method: 'get' });
}

export function deleteStatisticGraph(payload: { idArr: string[] }) {
  return axs({ url: `${basePath}/config`, method: 'delete', data: payload });
}

// export function createProjectSync(payload: {
//   projectCode: string;
//   partnerGroupIdx: number;
//   cloudDataList: number[];
// }) {
//   return axs({ url: `${basePath}/sync`, method: 'post', data: payload });
// }

export function createStatisticGraph(payload: {
  version: number;
  clientGroupCode: string | null;
  type: string;
  material: string[];
  implant: string[];
  duration: string;
  groupOption: string;
  dataOption: string;
}) {
  return axs({ url: `${basePath}/config`, method: 'post', data: payload });
}
